import { Graphics, NineSlicePlane, Point, Sprite } from 'pixi.js';

import { Shared } from '../App';

export interface ScrollBarOpts
{
    barWidth: number,
    barHeight: number,
    thumbWidth: number,
    thumbHeight: number,
    scrollUpdate: (val: number) => void;
}

const tempP = new Point();

export class ScrollBar
{
    public view: Sprite;
    public width: number;
    public height: number;
    public val: number;
    public scrollVal: number;

    public thumb: NineSlicePlane;

    protected moveId: number;
    protected isDown: boolean;

    private _minPos: number;
    private _maxPos: number;
    private _scrollUpdate: (val: number) => void;
    private _onScrollWheel: (e: any) => void;

    constructor(o: ScrollBarOpts)
    {
        this.view = new Sprite();
        this.view.interactive = true;

        this.view.anchor.set(0.5);

        const bg = new Graphics();

        this.moveId = 99999999;
        this.isDown = false;
        this.scrollVal = 0;
        this.val = 0;
        this._scrollUpdate = o.scrollUpdate;

        bg.beginFill(0x0, 0.4);
        bg.drawRoundedRect(
            0, 0,
            o.barWidth,
            o.barHeight,
            10,
        );
        bg.position.set(-o.barWidth / 2, -o.barHeight / 2);
        this.view.addChild(bg);

        this.thumb = new NineSlicePlane(Shared.assets.getTexture('button-ninesliced-yellow'), 50, 50, 50, 50);

        this.thumb.width = o.thumbWidth;
        this.thumb.height = o.thumbHeight;
        this.thumb.x -= this.thumb.width / 2;
        this.thumb.y -= this.thumb.height / 2;

        this.view.addChild(this.thumb);

        this.width = o.barWidth;
        this.height = o.barHeight;
        
        this.view.on('mousedown', this.down, this);
        this.view.on('mouseup', this.up, this);
        this.view.on('mouseupoutside', this.up, this);

        this.view.on('touchstart', this.down, this);
        this.view.on('touchend', this.up, this);
        this.view.on('touchendoutside', this.up, this);
        this.view.on('touchcancel', this.up, this);
        
        this._onScrollWheel = this.onScrollWheel.bind(this);
        Shared.game.app.stage.canvas.addEventListener("wheel", this._onScrollWheel);

        // set thumb to top scroll position
        const halfHeight = this.height / 2;
        const halfThumb = this.thumb.height / 2;

        this._minPos = -halfHeight + halfThumb;
        this._maxPos = halfHeight - halfThumb;

        this.setThumbY(-500);
    }
    
    public setThumbY(val: number): void
    {
        if (val < this._minPos) val = this._minPos;
        if (val > this._maxPos) val = this._maxPos;
        
        this.val = val;
        this.scrollVal = 1 - ((this._maxPos - val) / (2 * this._maxPos));

        this._scrollUpdate(this.scrollVal);

        this.thumb.y = val - (this.thumb.height / 2);
    }

    protected down(e: any): void
    {
        
        this.moveId = e.data.identifier;

        this.isDown = true;
        const pos = e.data.getLocalPosition(this.view, tempP);
        
        this.setThumbY(pos.y);

        this.view.on('mousemove', this.move, this);
        this.view.on('touchmove', this.move, this);
    }

    protected up(e: any): void
    {
        if (this.moveId !== e.data.identifier) return;

        this.moveId = 99999999;

        this.isDown = false;

        this.view.off('mousemove', this.move, this);
        this.view.off('touchmove', this.move, this);
    }

    protected move(e: any): void
    {
        if (this.moveId !== e.data.identifier) return;
        const pos = e.data.getLocalPosition(this.view, tempP);

        // for some reason on samsung s6 devices getLocal position can return NaN
        // not sure why, but we should check!
        if (isNaN(pos.x) || isNaN(pos.x))
        {
            pos.x = 0;
            pos.y = 0;
        }

        this.setThumbY(pos.y);
    }
    
    protected onScrollWheel(e: any): void
    {
        this.setThumbY(this.val + (e.deltaY * 0.46));
    }
}
